import { render, staticRenderFns } from "./IncorporationFormsDetails.vue?vue&type=template&id=b90b6dce&scoped=true&"
import script from "./IncorporationFormsDetails.vue?vue&type=script&lang=js&"
export * from "./IncorporationFormsDetails.vue?vue&type=script&lang=js&"
import style0 from "./IncorporationFormsDetails.vue?vue&type=style&index=0&id=b90b6dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90b6dce",
  null
  
)

export default component.exports